import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GlobalStyles } from './components/GlobalStyles';
import { TELEGRAM_WEB_APP_SCRIPT_URL } from './components/Api_url';
import { loadTelegramWebApp } from './components/loadTelegramWebApp';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
void loadTelegramWebApp(TELEGRAM_WEB_APP_SCRIPT_URL).then(() => {
  root.render(
    <React.StrictMode>
      <GlobalStyles />
      <App />
    </React.StrictMode>
  );
});
